import GlobalConfigEditDialog from './GlobalConfigEditDialog'

export default GlobalConfigEditDialog
